/* eslint-disable no-throw-literal */
import _ from 'lodash';

import { handleErrors } from './ErrorActions';
import { addWarning } from './WarningActions';
import * as RegulatoryTerms from '../api/regulatory-terms';
import { WARNING_SOURCES } from '../constants/WarningsConstants';
import { isNilOrEmpty } from '../utils/ramdaUtils';

export const MEDDRA_GET_CONTENT = 'RegulatoryTermsActions/MEDDRA_GET_CONTENT';
export const MEDDRA_GET_CONTENT_SUCCESS = 'RegulatoryTermsActions/MEDDRA_GET_CONTENT_SUCCESS';
export const MEDDRA_GET_CONTENT_FAILED = 'RegulatoryTermsActions/MEDDRA_GET_CONTENT_FAILED';
export const MEDDRA_CHILDREN_GET_CONTENT = 'RegulatoryTermsActions/MEDDRA_CHILDREN_GET_CONTENT';
export const MEDDRA_CHILDREN_GET_CONTENT_SUCCESS =
  'RegulatoryTermsActions/MEDDRA_CHILDREN_GET_CONTENT_SUCCESS';
export const MEDDRA_CHILDREN_GET_CONTENT_FAILED =
  'RegulatoryTermsActions/MEDDRA_CHILDREN_GET_CONTENT_FAILED';
export const DEFAULT_DICTIONARY_GET_CONTENT =
  'RegulatoryTermsActions/DEFAULT_DICTIONARY_GET_CONTENT';
export const DEFAULT_DICTIONARY_GET_CONTENT_SUCCESS =
  'RegulatoryTermsActions/DEFAULT_DICTIONARY_GET_CONTENT_SUCCESS';
export const DEFAULT_DICTIONARY_GET_CONTENT_FAILED =
  'RegulatoryTermsActions/DEFAULT_DICTIONARY_GET_CONTENT_FAILED';
export const GET_PREDICTION = 'RegulatoryTermsActions/GET_PREDICTION';
export const GET_PREDICTION_SUCCESS = 'RegulatoryTermsActions/GET_PREDICTION_SUCCESS';
export const GET_PREDICTION_FAILED = 'RegulatoryTermsActions/GET_PREDICTION_FAILED';
export const CLEAR_PREDICTION = 'RegulatoryTermsActions/CLEAR_PREDICTION';

export const getDictionary = (type, data, isSearchedData = false) => async (dispatch) => {
  switch (type) {
    case 'MEDDRA':
      dispatch(getMEDDRADictionary(data, isSearchedData));
      break;
    default:
      dispatch(getDefaultDictionary(data, isSearchedData));
      break;
  }
};

const getMEDDRADictionarySucess = (data, isSearchedData) => ({
  type: MEDDRA_GET_CONTENT_SUCCESS,
  payload: { data, isSearchedData },
});

export const getMEDDRADictionary = (data, isSearchedData = false) => async (dispatch) => {
  dispatch({ type: MEDDRA_GET_CONTENT });
  try {
    const response = await RegulatoryTerms.getDictionary(data);

    if (response.data.hasError) {
      throw response.data.errors;
    }

    if (isNilOrEmpty(response.data.Result) || isNilOrEmpty(response.data.Result[0])) {
      throw { message: 'Bad data result' };
    }

    dispatch(getMEDDRADictionarySucess(response.data.Result, isSearchedData));
  } catch (error) {
    dispatch({ type: MEDDRA_GET_CONTENT_FAILED });
    dispatch(handleErrors(error, { isTopBanner: true }));

    return Promise.reject(error);
  }
};

const getMEDDRAChildrenSucess = (data, path) => ({
  type: MEDDRA_CHILDREN_GET_CONTENT_SUCCESS,
  payload: { data, path },
});

export const getMEDDRAChildren = (node, path) => async (dispatch) => {
  dispatch({ type: MEDDRA_CHILDREN_GET_CONTENT });
  try {
    const { Code, ParentCode, TermHierarchy } = _.get(path, [0], {});

    const response = await RegulatoryTerms.getMEDDRAChildren({
      ...node,
      ParentCode: TermHierarchy === 'SOC' ? Code : ParentCode,
    });

    if (response.data.hasError) {
      throw response.data.errors;
    }

    if (isNilOrEmpty(response.data.Result)) {
      throw { message: 'Bad data result' };
    }

    dispatch(getMEDDRAChildrenSucess(response.data.Result, path));
  } catch (error) {
    dispatch({ type: MEDDRA_CHILDREN_GET_CONTENT_FAILED });
    dispatch(handleErrors(error, { isTopBanner: true }));

    return Promise.reject(error);
  }
};

const getDefaultDictionarySucess = (data, isSearchedData) => ({
  type: DEFAULT_DICTIONARY_GET_CONTENT_SUCCESS,
  payload: { data, isSearchedData },
});

export const getDefaultDictionary = (data, isSearchedData = false) => async (dispatch) => {
  dispatch({ type: DEFAULT_DICTIONARY_GET_CONTENT });
  try {
    const response = await RegulatoryTerms.getDictionary(data);

    if (response.data.hasError) {
      throw response.data.errors;
    }

    if (isNilOrEmpty(response.data.Result) || isNilOrEmpty(response.data.Result[0])) {
      throw { message: 'Bad data result' };
    }

    dispatch(getDefaultDictionarySucess(response.data.Result, isSearchedData));
  } catch (error) {
    dispatch({ type: DEFAULT_DICTIONARY_GET_CONTENT_FAILED });
    dispatch(handleErrors(error, { isTopBanner: true }));

    return Promise.reject(error);
  }
};

export const getPrediction = (data, targetField) => async (dispatch) => {
  if (!data) {
    const idx1 = targetField.indexOf('{|');
    const idx2 = targetField.indexOf('|}', idx1);
    const match = targetField.substring(idx1 + 2, idx2);
    const translatedFieldName = match.split('|')[0];

    dispatch(
      addWarning({
        message: `Data is required in the '${translatedFieldName}' field in order to run the Device Problem Code Assistant`,
        source: WARNING_SOURCES.ASSISTANT,
      })
    );
    return;
  }

  dispatch({ type: GET_PREDICTION });
  try {
    const response = await RegulatoryTerms.getPrediction(data);

    if (response.data.hasError) {
      throw response.data.errors;
    }

    dispatch(getPredictionSucess(response.data.PredictedData));
  } catch (error) {
    dispatch({ type: GET_PREDICTION_FAILED });
    dispatch(handleErrors(error, { isTopBanner: true }));

    return Promise.reject(error);
  }
};

const getPredictionSucess = (data) => ({
  type: GET_PREDICTION_SUCCESS,
  payload: { data },
});

export const clearPredictions = () => ({
  type: CLEAR_PREDICTION,
});
